import styled from 'styled-components';
import { FlexContainer, Accordion } from '@taxdown/piccolo-web';
import { MOBILE_WIDTH } from 'Styles/variables/sizes';

export const Faq = styled(FlexContainer)`
  background: ${({ theme: { colors } }) => colors.moon_100};
`;

export const FaqContent = styled(FlexContainer)`
  padding: ${({ theme: { sizing } }) => `${sizing.fds_size_40} ${sizing.fds_size_48}`};
  width: 100%;
  max-width: 1060px;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    padding: ${({ theme: { sizing } }) => sizing.fds_size_16};
  }
`;

export const FaqAccordion = styled(Accordion)`
  .accordion-parent {
    border: 1px solid ${({ theme: { colors } }) => colors.moon_500};
    border-radius: ${({ theme: { sizing } }) => sizing.fds_borderradius_M};
  }
  span {
    font-weight: bold;
  }
  .accordion-parent__trigger > div {
    padding: ${({ theme: { sizing } }) => `22px ${sizing.fds_size_16}`};
  }
`;

export const Link = styled.a`
  text-decoration: underline;
`;
